export const SITE_PROVIDERS_TABLE_UNIQUE_ID = 'site-providers';

export const SITE_PROVIDERS_TABLE_ROW_HEIGHT = 48;

/**
 * Initial width of every column of the site Providers table, keyed by the same `col-*` class
 * the header and row cells in site-providers-table.html / site-providers-table-row.html carry.
 *
 * `col-name` and `col-actions` are not free choices: TableColumnManager pins that exact pair to
 * the left and right edges, which keeps the provider name and the row menu in place while the
 * table scrolls sideways.
 *
 * Keep in sync with _site-providers-table-columns.scss - the SCSS map lays the columns out on
 * first paint, this map is what the resize engine falls back to for a column the user never
 * resized.
 */
export const SITE_PROVIDERS_TABLE_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-name': 220,
  'col-description': 220,
  'col-type': 220,
  'col-resolver': 260,
  'col-active': 100,
  'col-actions': 48
};
